import { render, staticRenderFns } from "./feedBackComp.vue?vue&type=template&id=fd6ab1f2&scoped=true&"
import script from "./feedBackComp.vue?vue&type=script&lang=js&"
export * from "./feedBackComp.vue?vue&type=script&lang=js&"
import style0 from "./feedBackComp.vue?vue&type=style&index=0&id=fd6ab1f2&scoped=true&lang=css&"
import style1 from "./feedBackComp.vue?vue&type=style&index=1&id=fd6ab1f2&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd6ab1f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/www/game/xcp-vue-xcll/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fd6ab1f2')) {
      api.createRecord('fd6ab1f2', component.options)
    } else {
      api.reload('fd6ab1f2', component.options)
    }
    module.hot.accept("./feedBackComp.vue?vue&type=template&id=fd6ab1f2&scoped=true&", function () {
      api.rerender('fd6ab1f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/xcpCustomerService/feedBackReply/components/feedBackComp.vue"
export default component.exports